import {
  __export
} from "./chunk-3IID4MV4.mjs";

// src/Toast.style.tsx
import {
  css as css2,
  keyframes
} from "@emotion/react";

// ../font/dist/index.mjs
var dist_exports = {};
__export(dist_exports, {
  bodyB: () => bodyB,
  bodyCompact: () => bodyCompact,
  bodyLong: () => bodyLong,
  bodyM: () => bodyM,
  captionM: () => captionM,
  captionSb: () => captionSb,
  heroTitle: () => heroTitle,
  largeTitle: () => largeTitle,
  subTitle1: () => subTitle1,
  subTitle2: () => subTitle2,
  subTitle3: () => subTitle3,
  tag1M: () => tag1M,
  tag1Sb: () => tag1Sb,
  tag2: () => tag2,
  title1: () => title1,
  title2: () => title2
});

// ../font/dist/chunk-UOJNIETM.mjs
var fontPretendard = "Pretendard";

// ../font/dist/chunk-ASJFQN6S.mjs
import { css } from "@emotion/react";
var heroTitle = css`
  font-family: ${fontPretendard};
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 52px;
`;
var largeTitle = css`
  font-family: ${fontPretendard};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px;
`;
var title1 = css`
  font-family: ${fontPretendard};
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
`;
var title2 = css`
  font-family: ${fontPretendard};
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
`;
var subTitle1 = css`
  font-family: ${fontPretendard};
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
`;
var subTitle2 = css`
  font-family: ${fontPretendard};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
`;
var subTitle3 = css`
  font-family: ${fontPretendard};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;
var bodyB = css`
  font-family: ${fontPretendard};
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
`;
var bodyCompact = css`
  font-family: ${fontPretendard};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
`;
var bodyM = css`
  font-family: ${fontPretendard};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
`;
var bodyLong = css`
  font-family: ${fontPretendard};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;
var captionSb = css`
  font-family: ${fontPretendard};
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;
var captionM = css`
  font-family: ${fontPretendard};
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
var tag1Sb = css`
  font-family: ${fontPretendard};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
`;
var tag1M = css`
  font-family: ${fontPretendard};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`;
var tag2 = css`
  font-family: ${fontPretendard};
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;

// ../utils/dist/chunk-VFZ6VXUK.mjs
function validateHexColor(hex) {
  return /^#([A-Fa-f0-9]{3}){1,2}$/.test(hex);
}
function expandShortHex(hex) {
  return hex.slice(1).split("").map((char) => char + char).join("");
}
function opacityToHex(opacity) {
  const alpha = Math.round(opacity * 255);
  return alpha.toString(16).padStart(2, "0").toUpperCase();
}
function applyOpacityToHexColor(hex, opacity) {
  if (!validateHexColor(hex)) {
    throw new Error("Invalid HEX color.");
  }
  const fullHex = hex.length === 4 ? `#${expandShortHex(hex)}` : hex;
  const alphaHex = opacityToHex(opacity);
  return `${fullHex}${alphaHex}`;
}

// ../utils/dist/chunk-TOX7GYF3.mjs
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// ../utils/dist/chunk-ARS7TIRV.mjs
import * as React from "react";
import { jsx } from "react/jsx-runtime";
function createContext2(rootComponentName, defaultContext) {
  const Context = React.createContext(
    defaultContext
  );
  function Provider(props) {
    const _a = props, { children } = _a, context = __objRest(_a, ["children"]);
    const value = React.useMemo(
      () => context,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Object.values(context)
    );
    return /* @__PURE__ */ jsx(Context.Provider, { value, children });
  }
  function useContext2(consumerName) {
    const context = React.useContext(Context);
    if (context)
      return context;
    if (defaultContext !== void 0)
      return defaultContext;
    throw new Error(
      `\`${consumerName}\` must be used within \`${rootComponentName}\``
    );
  }
  Provider.displayName = rootComponentName + "Provider";
  return [Provider, useContext2];
}

// ../utils/dist/chunk-SJSP2D73.mjs
function getVar(variable, fallback) {
  return `var(${variable}, ${fallback})`;
}

// ../utils/dist/chunk-AA64JA3L.mjs
function isObject(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

// ../../node_modules/.pnpm/@teamsparta+utils@1.2.20/node_modules/@teamsparta/utils/dist/index.mjs
function isNumber(value) {
  return typeof value === "number";
}
var CASE_SPLIT_PATTERN = new RegExp("[A-Z]?[a-z]+|[0-9]+|[A-Z]+(?![a-z])|\\p{Emoji_Presentation}|\\p{Extended_Pictographic}|\\p{L}+", "gu");
var MILLISECOND = 1;
var SECOND = MILLISECOND * 1e3;
var MINUTE = SECOND * 60;
var HOUR = MINUTE * 60;
var DAY = HOUR * 24;
var MONTH = DAY * 30;
var YEAR = MONTH * 12;

// src/Toast.style.tsx
import { Fragment } from "react";
import { jsx as jsx2 } from "@emotion/react/jsx-runtime";
var EXIT_DURATION = 300;
var ENTER_DURATION = 300;
var DEFAULT_OFFSET = 16;
var DEFAULT_BACKGROUND_COLOR = "#5F666B";
var toastSizeVariants = {
  md: {
    padding: "10px 14px"
  },
  lg: {
    padding: "12px 16px"
  }
};
var toastMessageWrapperVariants = {
  md: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0 2px"
  },
  lg: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0 4px"
  }
};
var toastMessageFontVariants = {
  md: bodyB,
  lg: subTitle3
};
var positionX = {
  center: () => css2`
    left: 50%;
    transform: translateX(-50%);
  `
};
var positionY = {
  top: (offset) => css2`
    top: ${offset};
  `,
  bottom: (offset) => css2`
    bottom: ${offset};
  `
};
var toastBaseCss = (type) => type !== "custom" ? css2({
  position: "fixed",
  borderRadius: "100px",
  backgroundColor: applyOpacityToHexColor(DEFAULT_BACKGROUND_COLOR, 0.8),
  backdropFilter: "blur(15px)",
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  zIndex: Number.MAX_SAFE_INTEGER
}) : css2({
  position: "fixed",
  zIndex: Number.MAX_SAFE_INTEGER
});
var toastAddonCss = css2({
  padding: "0 8px",
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  marginLeft: "auto"
});
var toastSizeCss = (sizes) => sizes.map(
  ({ breakpoint, size }) => css2`
      @media (min-width: ${breakpoint}px) {
        ${toastSizeVariants[size]}
      }
    `
);
var toastStretchCss = (stretchs) => stretchs.map(
  ({ breakpoint, stretch }) => css2`
      @media (min-width: ${breakpoint}px) {
        width: ${stretch ? "calc(100vw - 32px)" : "auto"};
        max-width: ${stretch ? "500px" : "none"};
      }
    `
);
var toastMessageWrapperCss = (sizes) => sizes.map(
  ({ breakpoint, size }) => css2`
      @media (min-width: ${breakpoint}px) {
        ${toastMessageWrapperVariants[size]}
      }
    `
);
var toastMessageFontCss = (sizes) => sizes.map(
  ({ breakpoint, size }) => css2`
      @media (min-width: ${breakpoint}px) {
        ${toastMessageFontVariants[size]}
      }
    `
);
var swipeInAnimation = (positionX2, positionY2, offset) => keyframes`
  from {
    opacity: 0;
    transform: translateX(${positionX2 === "center" ? "-50%" : 0}) translateY(${positionY2 === "top" ? "-" : ""}${offset});
  }

  to {
    opacity: 1;
    transform: translateX(${positionX2 === "center" ? "-50%" : 0}) translateY(0);
  }
`;
var fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
var swipeOutAnimation = (positionX2, positionY2, offset) => keyframes`
  from {
    opacity: 1;
    transform: translateX(${positionX2 === "center" ? "-50%" : 0}) translateY(0);
  }

  to {
    opacity: 0;
    transform: translateX(${positionX2 === "center" ? "-50%" : 0}) translateY(${positionY2 === "top" ? "-" : ""}${offset});
  }
`;
var fadeOutAnimation = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;
var toastPositionCss = ({
  positions,
  offsets,
  dismiss,
  immediateDismiss,
  immediateEnter
}) => positions.map(({ breakpoint, position }) => {
  var _a, _b;
  const [y, x] = position.split("-");
  const offset = offsets.length === 1 ? offsets[0].offset : (_b = (_a = offsets.find(({ breakpoint: b }) => b === breakpoint)) == null ? void 0 : _a.offset) != null ? _b : DEFAULT_OFFSET;
  const calculatedOffset = isNumber(offset) ? `${offset}px` : offset;
  const enterAnimation = immediateEnter ? fadeInAnimation : swipeInAnimation(x, y, calculatedOffset);
  const exitAnimation = immediateDismiss ? fadeOutAnimation : swipeOutAnimation(x, y, calculatedOffset);
  return css2`
      @media (min-width: ${breakpoint}px) {
        top: auto;
        bottom: auto;
        left: auto;
        right: auto;
        transform: none;
        animation: ${enterAnimation} ${ENTER_DURATION}ms forwards;

        ${dismiss && css2`
          animation: ${exitAnimation} ${EXIT_DURATION}ms forwards;
        `};

        ${positionX[x](calculatedOffset)};
        ${positionY[y](calculatedOffset)}
      }
    `;
});
function byBreakpoints(nodes) {
  return /* @__PURE__ */ jsx2(Fragment, { children: nodes.map(({ breakpoint, node }, index) => {
    var _a;
    const nextBreakpoint = (_a = nodes[index + 1]) == null ? void 0 : _a.breakpoint;
    return /* @__PURE__ */ jsx2(
      "span",
      {
        css: css2`
              display: none;

              @media (min-width: ${breakpoint}px) {
                display: contents;
              }

              ${nextBreakpoint && `@media (min-width: ${nextBreakpoint}px) {
                    display: none;
                  }`}
            `,
        children: node
      },
      breakpoint
    );
  }) });
}

export {
  dist_exports,
  createContext2,
  getVar,
  isObject,
  EXIT_DURATION,
  toastBaseCss,
  toastAddonCss,
  toastSizeCss,
  toastStretchCss,
  toastMessageWrapperCss,
  toastMessageFontCss,
  toastPositionCss,
  byBreakpoints
};
